import { Inject, Injectable } from '@angular/core';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { IWaterSupplyZoneGeo } from './water-supply-zone.model';
import { HttpClient } from '@angular/common/http';
import { ApiWszService } from 'src/app/core/services/api-wsz.service';
import { CrudWszService } from 'src/app/core/services/crud-wsz.service';
import { QueryWszService } from 'src/app/core/services/query-wsz.service';
import { WATERSUPPLYZONE_GEO_ENDPOINT, WATERSUPPLYZONE_GEO_QUERY_SERVICE_INSTANCE } from './water-supply-zone-all.config';
import { IPuntoCampionamento } from '../punti-campionamento/punti-campionamento.model';
import { map, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class WaterSupplyZoneGeoService extends CrudWszService<IWaterSupplyZoneGeo> {

  constructor(
    @Inject(WATERSUPPLYZONE_GEO_QUERY_SERVICE_INSTANCE) public readonly query: QueryWszService<IWaterSupplyZoneGeo>,
    @Inject(ApiWszService) protected override readonly api: ApiWszService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService,
    private http: HttpClient,
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(WATERSUPPLYZONE_GEO_ENDPOINT, api, snackbar);

  }

  getById(id:number | string){
   return this.api.get("wsz?id="+id)
  }

  modifyWsz(id:number | string, data:any){
    return this.api.put("wsz?id="+id, data)
  }

  deleteWsz(id:number | string){
    return this.api.delete("wsz?id="+id)
  }

  getPuntiCampionamento(id: number | string): Observable<IPuntoCampionamento[]> {
    return this.api.get<{ content: IPuntoCampionamento[] }>("wsz/pc?id=" + id).pipe(
      map(response => response.content)
    );
  }

}
